module.exports = __webpack_public_path__ + "images/emoji/palm_tree.e7f8b0ac8ded83a1ee5a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/palm_tree.png
// module id = 4nLi
// module chunks = 1